import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { RenovacaoCadastralService } from '@/core/api/sicom-api/servicos/pessoa-juridica/renovacao-cadastral/renovacao-cadastral.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { RenovacaoCadastralRequest, RenovacaoCadastralResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/renovacao-cadastral/renovacao-cadastral.model';

@Injectable({ providedIn: 'root' })
export class RenovacaoCadastralServicosService {
    constructor(
        private api: RenovacaoCadastralService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: RenovacaoCadastralRequest, context?: HttpContext): Observable<RenovacaoCadastralResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
